import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">为什么选择我们</h2>
          <div className="w-12 h-1 bg-accent-500 mx-auto rounded-full"></div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {featuresData.map((item, idx) => (
            <div key={item.id} className="bg-background-50 rounded-xl p-5 border border-background-200/70 text-center group hover:border-accent-300 transition-all duration-300">
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center mx-auto mb-4 transition-colors duration-300 ${
                idx % 3 === 0 ? 'bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50' :
                idx % 3 === 1 ? 'bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50' :
                'bg-secondary-100 text-secondary-600 group-hover:bg-secondary-500 group-hover:text-background-50'
              }`}>
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}